import { TerminalVersionDtoToEntity } from "src/app/features/TerminalVersion/services/mappers/TerminalVersionDtoToEntity";
import type { TerminalVersionEntity } from "src/app/features/TerminalVersion/types/TerminalVersionEntity";
import { getAssignedDataGroup } from "../../../../../core/router/auth";
import { ResourceName } from "../../../../../core/router/config/ResourceName";
import { baseAuthApi } from "../../../../../core/service/baseApi";
import type { FormQuery } from "../../../../../core/service/types/FormQuery";
import type { Dto } from "../../../../../core/types/be/Dto";

const TerminalVersionApi = baseAuthApi.injectEndpoints({
    endpoints: (builder) => ({
        TerminalVersionLoad: builder.query<TerminalVersionEntity, FormQuery>({
            providesTags: [ResourceName.TERMINAL_VERSIONS],
            query: (queryParams) => {
                const dataGroup = getAssignedDataGroup();
                return {
                    url: `${ResourceName.DATA_GROUPS}/${dataGroup?.code}/${ResourceName.TERMINAL_VERSIONS}/${queryParams.entityId}`,
                    method: "GET",
                };
            },
            transformResponse: (response: Dto, _) => {
                return TerminalVersionDtoToEntity(response);
            },
        }),
    }),
});

export const { useTerminalVersionLoadQuery } = TerminalVersionApi;
